import styled from 'styled-components';

export const PaginationInfo = styled.div`
  color: var(--color-text-muted);
  font-size: 12px;
`;
